import { Modal, ModalProps } from 'modules/modal/ui/Modal'
import { Text } from 'shared/ui/common/Text'
import { Title } from 'shared/ui/common/Title'
import { Button } from 'shared/ui/controls/Button'

import s from './BorrowModal.module.scss'

type Props = {
  onContinue: () => void
} & ModalProps

export const BorrowModal = (props: Props) => {
  const { onContinue, ...rest } = props
  return (
    <Modal {...rest} width={690}>
      <Title className={s.title} isUppercased isCentered>
        RociFi will fetch your credit score
      </Title>
      <Text className={s.text} size={20} weight={400} isCentered>
        Borrow LTV & APR offer might be different
        <br />
        from the one you selected
      </Text>
      <Button onClick={onContinue} size={72} isFullWidth>
        Start borrowing
      </Button>
    </Modal>
  )
}
